import { axios } from '@/services/axios';

const updateWholesaler = async (formData) => {
    const response = await axios.put('/wholesaler/', formData);
    return response.data;
};

export default updateWholesaler;
